export type LocomotionState = 'SURFACE' | 'FREE_FLIGHT' | 'LANDING';

/** The legal transitions between locomotion states. */
export const LOCOMOTION_TRANSITIONS: Record<LocomotionState, readonly LocomotionState[]> = {
  SURFACE: ['FREE_FLIGHT'],
  FREE_FLIGHT: ['LANDING'],
  LANDING: ['SURFACE', 'FREE_FLIGHT'],
};

/**
 * The player's locomotion state machine.
 *
 *   SURFACE  --launch / walk off an edge-->  FREE_FLIGHT
 *   FREE_FLIGHT  --surface contact-->        LANDING
 *   LANDING  --adhesion acquired-->          SURFACE
 *   LANDING  --timeout / lost contact-->     FREE_FLIGHT
 */
export class LocomotionStateMachine {
  private currentState: LocomotionState = 'SURFACE';
  private readonly stateHistory: LocomotionState[] = ['SURFACE'];

  get state(): LocomotionState {
    return this.currentState;
  }

  get history(): readonly LocomotionState[] {
    return this.stateHistory;
  }

  canTransition(to: LocomotionState): boolean {
    return LOCOMOTION_TRANSITIONS[this.currentState].includes(to);
  }

  /** Returns false when the transition is not legal. */
  transition(to: LocomotionState): boolean {
    if (to === this.currentState) return true;
    if (!this.canTransition(to)) return false;
    this.currentState = to;
    this.stateHistory.push(to);
    if (this.stateHistory.length > 32) this.stateHistory.shift();
    return true;
  }

  reset(): void {
    this.currentState = 'SURFACE';
    this.stateHistory.length = 0;
    this.stateHistory.push('SURFACE');
  }
}
